class ProductSubscription {
    constructor(wrapperId) {
        this.wrapper = document.getElementById(wrapperId)
        const products = document.querySelectorAll('.variant-override-item')
        products.forEach((variant) => {
            variant.addEventListener('click', this.onVariantChange.bind(this))
        })
      
        this.active = document.querySelector('.variant-override-item.active')

        this.formName = 'subscription-product-form'
        this.form = document.getElementById(this.formName)
    }

    init(product) {
        this.addRechargeWidget(product)
        this.generateCustomCss(product)
    }

    update (product) {
        this.removeRechargeWidgets()
        this.addRechargeWidget(product)
    }

    async onVariantChange (event) {
        event.preventDefault();
        this.active.classList.remove('active')
        this.active = event.target
        this.active.classList.add('active')
      console.log(event)
        await this.updateContent()
      
    }

    async updateContent () {
        const data = this.active.dataset
        const id = data.id
        const variant = data.variant
        const className = `.pvo-${id}`
        const handle = data.handle
        const details = await this.getProductDetails(handle)

        // change color scheme
        this.generateCustomCss(id)

        // toggle hidden contents
        this.wrapper.querySelectorAll('[class*="pvo-"]').forEach((variant) => {
           variant.classList.add('hidden')
        })
        this.wrapper.querySelectorAll(className).forEach((variant) => {
            variant.classList.remove('hidden')
        })

        if (details.title) {
            this.wrapper.querySelector('.product-title').innerHTML = details.title
        }

        // update details for adding to cart
        this.updateAddToCart(variant, handle, id)

        // update review count
        //this.updateYotpo(id)

        // update recharge widget
        this.update(id)
    }

    updateYotpo (productId) {
        this.wrapper.querySelector('.yotpo.bottomLine').dataset.productId = productId
        const api = new Yotpo.API(yotpo);
        api.refreshWidgets();
    }

    getProductDetails (handle) {
        return fetch(`/products/${handle}.js`).then((res) => res.json()).then((response) => {
            return response
        })
    }

    updateAddToCart (variant, handle, productId) {
console.log('--- updateAddToCart ---')
    console.log('Variant ID:', variant)
    console.log('Product Handle:', handle)
    console.log('Product ID:', productId)

      
        this.form.querySelector('input[name="product-id"]').value = productId
        this.form.querySelector('select[name="id"]').options[0].value = variant
        this.form.dataset.productHandle = handle
    }

    addRechargeWidget(productId) {
        if (typeof ReChargeWidget != "undefined") {
            const config = {
                productId: parseInt(productId),
                injectionParent: `form#${this.formName}`, // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected
                injectFn: (node, target) => {}, // Runs a custom injection function
            };
            window.ReChargeWidget.createWidget(config);

            setTimeout(() => {
                this.wrapper.querySelector('.rc_widget__option__input--subsave').click() // switch to subscribe option
            }, 1000)

        } else {
            console.log('recharge undefined')
        }
    }

    removeRechargeWidgets () {
        this.wrapper.querySelectorAll('.rc-container-wrapper').forEach((widget) => widget.remove())
    }

    onFrequencyChange (event) {
        event.preventDefault()
        console.log('frequency changed')
        const rechargePrice = this.wrapper.querySelector('.recharge-inner-most-price').innerHTML
        const defaultPrice = this.wrapper.querySelector('.product-regular-price').innerHTML
        if (rechargePrice !== defaultPrice) {
            this.wrapper.querySelector('.product-regular-price').classList.remove('hidden')
            this.wrapper.querySelector('.product-regular-price').classList.add('active')
        } else {
            this.wrapper.querySelector('.product-regular-price').classList.add('hidden')
            this.wrapper.querySelector('.product-regular-price').classList.remove('active')
        }
    }

    generateCustomCss(product) {
        const tint = this.wrapper.querySelector(`#product-${product}`).dataset.tint
        if (tint) {
            this.wrapper.style.backgroundColor = tint
        }
    }


}

const selectedProduct = parseInt(document.getElementById('subscription-product').dataset.productId)
const instance = new ProductSubscription('subscription-product')

setTimeout(() => {
    instance.init(selectedProduct)
}, 5000)